var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogoTwitter1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6001 6.13783C20.8801 6.43783 20.1601 6.67783 19.3201 6.73783C20.1601 6.25783 20.7601 5.47783 21.0601 4.57783C20.2801 5.05783 19.4401 5.35783 18.5401 5.53783C17.8201 4.75783 16.8001 4.27783 15.7201 4.27783C13.5601 4.27783 11.7601 6.01783 11.7601 8.23783C11.7601 8.53783 11.8201 8.83783 11.8801 9.13783C8.58009 8.95783 5.70009 7.39783 3.72009 4.99783C3.36009 5.59783 3.18009 6.25783 3.18009 6.97783C3.18009 8.35783 3.90009 9.55783 4.92009 10.2778C4.26009 10.2778 3.66009 10.0978 3.12009 9.79783V9.85783C3.12009 11.7778 4.50009 13.3378 6.30009 13.6978C5.94009 13.7578 5.64009 13.8178 5.28009 13.8178C5.04009 13.8178 4.80009 13.8178 4.56009 13.7578C5.04009 15.3178 6.54009 16.4578 8.22009 16.5178C6.90009 17.5978 5.16009 18.1978 3.30009 18.1978C3.00009 18.1978 2.64009 18.1978 2.34009 18.1378C4.14009 19.2178 6.24009 19.8778 8.46009 19.8778C15.7201 19.8778 19.6801 13.8778 19.6801 8.65783C19.6801 8.47783 19.6801 8.29783 19.6801 8.17783C20.4001 7.57783 21.0601 6.91783 21.6001 6.13783Z",
    fill: "#2EBAE8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTwitter1);
export default __webpack_public_path__ + "static/media/logo-twitter-1.302d3563dbb6e43b618b5cceeb384dfc.svg";
export { ForwardRef as ReactComponent };